import { isNotNil } from '../nil/is-not-nil';

export function isObject(predictable: unknown): predictable is object {
  return !!(typeof predictable === 'object' && isNotNil(predictable));
}
